// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/location.js#1 $
'use strict';

/**
* @ngdoc service
* @name $location
* @description
* Add tkReplaced property to $location service, which indicates if current location was
* replaced with $location.url().replace() or just navigated normally.
* Also remove leading hash from url() calls to make it more compatible with location.href format
*/
angular.module('tcApp')
.config(function($provide) {
	$provide.decorator('$location', function($delegate, $rootScope) {
		var originalReplace = $delegate.replace;
		$delegate.replace = function() {
			$delegate.tkWillReplace = true;
			$delegate.tkReplaced = false;
			return originalReplace.apply($delegate);
		};

		$rootScope.$on('$locationChangeStart',function() { //eslint-disable-line
			$delegate.tkReplaced = $delegate.tkWillReplace;
			$delegate.tkWillReplace = false;
		});

		var originalUrl = $delegate.url;
		$delegate.url = function(url) {
			// Remove leading hash
			if (url && url[0] == '#') url = url.slice(1);
			return originalUrl.call($delegate,url);
		};
		
		return $delegate;
	});
});
/*.config(function($locationProvider) {
	$locationProvider.html5Mode(true);
	$locationProvider.hashPrefix('');
});
*/
